import { Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TaskDetailsPdfService } from '@app/shared/services/task-details-pdf.service';
import { Sections } from '@app/shared/types/models/pdf/task-details/sections.model';
import { Task } from '@app/shared/types/models/task/task.model';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { UiSpinnerDirective } from '@app/shared/ui/spinner/ui-spinner.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { TaskDetailsPdfComponent } from '../task-details-pdf/task-details-pdf.component';

export interface DialogData {
  task: Task;
}

@Component({
  selector: 'proffeo-task-details-pdf-dialog',
  templateUrl: './task-details-pdf-dialog.component.html',
  styleUrls: ['./task-details-pdf-dialog.component.scss'],
  providers: [TaskDetailsPdfService],
  imports: [UiDialogComponent, TranslatePipe, TaskDetailsPdfComponent, UiButtonComponent, UiSpinnerDirective]
})
export class TaskDetailsPdfDialogComponent implements OnInit {
  private readonly modalData: DialogData = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<TaskDetailsPdfDialogComponent> = inject(MatDialogRef);
  private readonly pdfService: TaskDetailsPdfService = inject(TaskDetailsPdfService);

  protected task: Task;
  protected isLoading = signal(false);
  protected sections: Sections | null = null;
  protected taskAction: string | undefined;
  protected taskAdditionalDetails: string | undefined;

  public ngOnInit(): void {
    this.task = this.modalData.task;
    this.pdfService.reset(this.task);
  }

  protected close(): void {
    this.dialogRef.close();
  }

  protected onPdfGenerate(): void {
    if (!this.sections) {
      return;
    }

    this.isLoading.set(true);
    this.dialogRef.disableClose = true;

    this.pdfService.generate(this.task, this.sections, this.taskAction, this.taskAdditionalDetails).subscribe({
      next: () => {
        this.isLoading.set(false);
        this.dialogRef.disableClose = false;
        this.dialogRef.close();
      },
      error: () => {
        this.isLoading.set(false);
        this.dialogRef.disableClose = false;
      }
    });
  }
}
